import { GET_CENTRO, MODIFY_FIELD_DETALLE_CENTRO, MODIFY_FIELDS_CENTRO_DIALOG, UPDATE_CENTRO } from '../constants/action_types';

const initialState = { centrodetalle: {}, isLoading: false, updated: false };

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_CENTRO:

            return { ...state, isLoading: true };

        case GET_CENTRO + "_SUCCESS":

            return {
                centrodetalle: action.payload.data,
                updated: false,
                isLoading: false
            };

        case MODIFY_FIELD_DETALLE_CENTRO:

            const field = action.payload[0],
                value = action.payload[1];

            return {
                centrodetalle: { ...state.centrodetalle, [field]: value },
                updated: false,
                isLoading: false
            };

        case MODIFY_FIELDS_CENTRO_DIALOG:

            return {
                centrodetalle: { ...state.centrodetalle, ...action.payload },
                updated: false,
                isLoading: false
            }

        case UPDATE_CENTRO:

            return { ...state, isLoading: true };

        case UPDATE_CENTRO + "_SUCCESS":

            return {
                centrodetalle: {},
                updated: true,
                isLoading: false
            };

        default:

            return state;
    };
};